import type {UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import type {DistrictAttrs} from '@freckle/educator-entities/ts/roster/models/district'
import {fetchDistricts} from '@freckle/educator-entities/ts/roster/models/district'

export function useDistricts(
  options?: Partial<UseQueryOptions<DistrictAttrs[]>>
): UseQueryResult<DistrictAttrs[]> {
  const defaultOptions = {staleTime: 60 * 1000}
  return useAsync(fetchDistricts, 'fetchDistricts', [], {
    ...defaultOptions,
    ...options
  })
}
